import { render, staticRenderFns } from "./buildings.vue?vue&type=template&id=00a7479c&scoped=true"
import script from "./buildings.vue?vue&type=script&lang=js"
export * from "./buildings.vue?vue&type=script&lang=js"
import style0 from "./buildings.vue?vue&type=style&index=0&id=00a7479c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a7479c",
  null
  
)

export default component.exports